import { render, staticRenderFns } from "./VvDesktopLessonStepTile.vue?vue&type=template&id=1774fe74&scoped=true&"
import script from "./VvDesktopLessonStepTile.vue?vue&type=script&lang=js&"
export * from "./VvDesktopLessonStepTile.vue?vue&type=script&lang=js&"
import style0 from "./VvDesktopLessonStepTile.vue?vue&type=style&index=0&id=1774fe74&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1774fe74",
  null
  
)

export default component.exports